import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CMS_COMPONENT_NORMALIZER, I18nModule, provideConfig } from '@spartacus/core'
import {
  ConsentManagementModule,
  GenericLinkModule,
  IconModule,
  KeyboardFocusModule
} from '@spartacus/storefront'
import { EBPipesModule } from 'src/app/components/pipes/eb-pipes.module'
import { EbSpinnerModule } from '../../components/spinner/eb-spinner.module'
import { EbCmsLinkComponentNormalizer } from '../converter/eb-cms-link-component-normalizer'
import { EbMyAccountModule } from '../myaccount/eb-my-account.module'
import { EbAboutUsComponent } from './components/about-us/eb-about-us.component'
import { EbAnonymousConsentDialogComponent } from './components/anonymous-consent-dialog/eb-anonymous-consent-dialog.component'
import { EbAnonymousConsentOpenDialogComponent } from './components/anonymous-consent-open-dialog/eb-anonymous-consent-open-dialog.component'
import { EbCopyRightComponent } from './components/copy-right/eb-copy-right.component'
import { defaultEbAnonymousConsentLayoutConfig } from './config/anonymous-consent-dialog-layout.config'
import { ebFooterLayoutConfig } from './config/eb-footer-layout.config'

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    KeyboardFocusModule,
    EbSpinnerModule,
    IconModule,
    ConsentManagementModule,
    GenericLinkModule,
    EbMyAccountModule,
    EBPipesModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        AboutUsComponent: {
          component: EbAboutUsComponent
        },
        CopyRightComponent: {
          component: EbCopyRightComponent
        },
        AnonymousConsentOpenDialogComponent: {
          component: EbAnonymousConsentOpenDialogComponent
        }
      }
    }),
    {
      provide: CMS_COMPONENT_NORMALIZER,
      useClass: EbCmsLinkComponentNormalizer,
      multi: true
    },
    provideConfig(defaultEbAnonymousConsentLayoutConfig),
    provideConfig(ebFooterLayoutConfig)
  ],
  declarations: [
    EbCopyRightComponent,
    EbAnonymousConsentOpenDialogComponent,
    EbAnonymousConsentDialogComponent,
    EbAboutUsComponent
  ],
  exports: [
    EbCopyRightComponent,
    EbAnonymousConsentOpenDialogComponent,
    EbAnonymousConsentDialogComponent,
    EbAboutUsComponent
  ]
})
export class EbFooterModule {}
